<template>
	<div class="content">

		<div class="md-layout">
			<div class="md-layout-item md-medium-size-100 md-size-100">

				<md-card>
					<md-card-header data-background-color="purple">
						<h4 class="title">{{$route.name}}</h4>
					</md-card-header>
					<md-card-content>
						<loading v-if="!loaded" />
						<div class="md-layout" v-if="loaded">
							<div class="md-layout-item md-small-size-100 md-size-100">
								<h3 class="order-title">កំណត់ចំណាំរបស់កញ្ចប់ឥវ៉ាន់</h3>
								<p v-if="String(package.package_note).length > 0">{{package.package_note}}</p>
								<p v-else>មិនមាន</p>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-100">
								<h3 class="order-title">កែប្រែកំណត់ចំណាំរបស់កញ្ចប់ឥវ៉ាន់</h3>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-25">
								<md-field>
									<label>ជ្រើសរើសស្ថានភាពកញ្ចប់ឥវ៉ាន់</label>
									<md-select placeholder="ជ្រើសរើសស្ថានភាពកញ្ចប់ឥវ៉ាន់" v-model="note">
										<md-option value="មិនមាន">មិនមាន</md-option>
										<md-option value="ទាក់ទងមិនបាន">ទាក់ទងមិនបាន</md-option>
										<md-option value="យកថ្ងៃស្អែក">យកថ្ងៃស្អែក</md-option>
										<md-option value="ប្តូរទីតាំង">ប្តូរទីតាំង</md-option>
										<md-option value="អីវ៉ាន់ខុស">អីវ៉ាន់ខុស</md-option>
									</md-select>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-70 md-size-25">
								<md-field>
									<label>កំណត់ចំណាំថ្មី</label>
									<md-input type="text" v-model="note"></md-input>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-30  md-size-20">
								<md-button class="md-raised md-success" @click="updateNote()">រក្សាទុក</md-button>
							</div>
						</div>
						<!-- <md-dialog-confirm :md-active.sync="payDialog" md-title="តើអ្នកពិតជាចង់ដាក់កញ្ចប់ឥវ៉ាន់នេះថាទូទាត់រួចឬ?"
							md-content="" md-confirm-text="OK" md-cancel-text="បោះបង់" @md-cancel="onCancel" @md-confirm="payPayment" /> -->
					</md-card-content>
				</md-card>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {
		},
		created() {
			this.getPackage();
			// this.getPayment();
		},
		data() {
			return {
				loaded: false,
				package: {
					id: "",
					hash_id: "",
					tracking: "",
					client_name: "",
					client_phone: "",
					client_note: "",
					location: "",
					receiver_phone: "",
					package_status: "",
					driver_note: "",
					package_note: "",
					driver_name: "",
					driver_phone: "",
					note: "",
					fee_responsible: ""
				},
				note: ""
			}
		},
		methods: {
			getPackage(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/package/get/" + this.$route.params.hash_id).then(data => {
					this.package = data.body.data
					// console.log(data.body.data)
					this.loaded = true
				})
			},
			updateNote() {
				this.$http.post(this.config.api + "/admin/package/note", {
						package_hash_id: this.$route.params.hash_id,
						package_note: this.note
					}).then(data => {
						if (data.body.status == 'success') {
							this.$notification.notify({
								message: "កញ្ចប់ឥវ៉ាន់ត្រូវបានកែប្រែកំណត់ចំណាំដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
							this.$router.push("/dashboard");
						}
					})
			},
			onCancel() {
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Note.vue